export class CartaResponse {
    cartas:Carta[];
    remitentes:any;
    destinatarios:any;
}

export class Carta{
    numeroCarta:string = '';
    fechaIngreso:string = '';
    responsable:string = '';
    direccionDestinatario:string = '';
    ubigeoDestinatario:string = '';
}